module.exports = __webpack_public_path__ + "img/ic_logo_bwin_small_white.50de899b.svg";